<template>
  <div class="study-progress" aria-label="Lesson progress">
    <p>{{ completed ? 'Finished!' : `Activity ${index + 1} of ${total}` }} <span>{{ completed ? 'All done' : title }}</span></p>
    <progress :value="completed ? total : index" :max="total">{{ index }} / {{ total }}</progress>
  </div>
</template>
<script>
export default { props: { index: Number, total: Number, title: String, completed: Boolean } };
</script>
